/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hidden[_ngcontent-%COMP%]{display:none}.visible[_ngcontent-%COMP%]{display:block}@media only screen and (max-width:750px){.sub-header[_ngcontent-%COMP%]{display:none}}.search-label[_ngcontent-%COMP%]{position:absolute;top:50%;left:10px;transform:translateY(-50%)}"];
export { styles as styles };
